import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  const navLinks = [
    { name: 'Home', path: '/#home', isRoute: false },
    { name: 'About', path: '/#about', isRoute: false },
    { name: 'Services', path: '/#services', isRoute: false },
    { name: 'Industries', path: '/#industries', isRoute: false },
    { name: 'Contact', path: '/#contact', isRoute: false },
  ];

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname === path;
  };

  const handleNavClick = (link) => {
    setIsMobileMenuOpen(false);
    if (!link.isRoute && link.path.includes('#')) {
      const hash = link.path.split('#')[1];
      if (location.pathname === '/') {
        const element = document.getElementById(hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    }
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <nav className="navbar">
        <div className="container">
          <div className="nav-content">
            <Link to="/" className="logo">
              <span className="logo-text">Sempersys<span className="logo-cursor">|.</span></span>
            </Link>

            <ul className={`nav-links ${isMobileMenuOpen ? 'active' : ''}`}>
              {navLinks.map((link, index) => (
                <li key={index}>
                  {link.isRoute ? (
                    <Link
                      to={link.path}
                      className={isActive(link.path) ? 'active' : ''}
                      onClick={() => handleNavClick(link)}
                    >
                      {link.name}
                    </Link>
                  ) : (
                    <Link
                      to={link.path}
                      onClick={() => handleNavClick(link)}
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>

            <Link to="/#contact" className="btn btn-primary nav-cta" onClick={() => handleNavClick({ path: '/#contact', isRoute: false })}>
              Let's Talk!
            </Link>

            <button
              className="mobile-toggle"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="Toggle menu"
            >
              {isMobileMenuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
